import { Link } from 'react-router-dom';
import React from 'react';

type Props = {
  onClick: () => void;
};

export const CommentReplayButton = (props: Props) => {
  return (
    <Link to="" className="d-inline-flex align-items-center" onClick={() => props.onClick()}>
      <i className="fas fa-undo me-1"></i>
      <span className="text-xs font-weight-bold">返信</span>
    </Link>
  );
};
